import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DisconnectDomainMutation } from "../graphql/mutations";
import type {
  DisconnectDomainMutationType,
  DisconnectDomainMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDisconnectDomainMutation = (
  options?: MutationHookOptions<
    DisconnectDomainMutationType,
    DisconnectDomainMutationVariablesType
  >
) => {
  return useMutation<
    DisconnectDomainMutationType,
    DisconnectDomainMutationVariablesType
  >(DisconnectDomainMutation, options);
};
